import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { CarouselComponent } from './carousel/carousel.component';
import { ServicesProvideComponent } from './services-provide/services-provide.component';
import { ChooseUsComponent } from './choose-us/choose-us.component';
import { TechnologiesComponent } from './technologies/technologies.component';
import { FeaturesProjectComponent } from './features-project/features-project.component';
import { ProductsComponent } from './products/products.component';
import { ClientsComponent } from './clients/clients.component';
import { ExtensiveReachComponent } from './extensive-reach/extensive-reach.component';


@NgModule({
  declarations: [HomeComponent, CarouselComponent, ServicesProvideComponent, ChooseUsComponent, TechnologiesComponent, FeaturesProjectComponent, ProductsComponent, ClientsComponent, ExtensiveReachComponent],
  imports: [
    CommonModule,
    HomeRoutingModule
  ], exports: [
    ChooseUsComponent
  ]
})
export class HomeModule { }
